/*
 * Copyright (c) 2023. Haodong JU
 */

import hillo from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import dayjs from 'dayjs'

const entity = {
  servantName: {},
  fromDate: {
    displayName: 'fromTime'
  },
  toDate: {
    displayName: 'toTime'
  },
  avgHourlyWage: {},
  totalIncome: {
    displayName: 'sumTotal'
  },
  totalWorkHour: {
    displayName: 'totalTimeInHour'
  }
}
const config = {
  load: async function (filter) {
    const [fromDateTime, toDateTime] = [dayjs(filter[0].dateFilter[0]).format('YYYY-MM-DD') + ' 04:00:00', dayjs(filter[0].dateFilter[1]).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59']
    const res = (await hillo.get('Servant.php?op=getClockInSummaryData', {
      fromDateTime,
      toDateTime
    })).content.map(it => {
      it.servantSummary.details = it.details
      return it.servantSummary
    })
    console.log(res, 'res')
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getStaffDetail (dateRange, servantId) {
  const [fromDateTime, toDateTime] = [dayjs(dateRange[0]).format('YYYY-MM-DD') + ' 04:00:00', dayjs(dateRange[1]).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59']
  return (await hillo.get('Servant.php?op=getClockInDetailData', {
    fromDateTime,
    toDateTime,
    servantId
  })).content.map(it => {
    it.dailySummary.details = it.details
    return it.dailySummary
  })
}

export async function downloadClockInExcel (dateRange) {
  const [fromDateTime, toDateTime] = [dayjs(dateRange[0]).format('YYYY-MM-DD') + ' 04:00:00', dayjs(dateRange[1]).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59']
  return (await hillo.get('Servant.php?op=downloadClockInExcel', {
    fromDateTime,
    toDateTime
  })).content.path
}
